import { lightningReportErrorEllipseConfidences } from '@xweather/protect-types'
import { z } from 'zod'
import { reportViews } from '../reportViews.ts'
import { strikeDamagePotentialOptions } from './lightningReportUtils.ts'
import { lightningEventColumnKeys } from './table/lightningEventColumnKeys.ts'

const SIGNAL_RANGE_PATTERN = /^(!?)(-?\d+)\.\.(-?\d+)$/

export const parseSignalRange = (value: string) => {
	const [, inverted, min, max] = SIGNAL_RANGE_PATTERN.exec(value) ?? []
	if (min === undefined || max === undefined || Number(min) > Number(max)) return undefined
	return { min: Number(min), max: Number(max), inverted: inverted === '!' }
}

export const LightningReportSearchSchema = z.object({
	view: z.enum(reportViews).optional().catch(undefined),
	sort: z.enum(lightningEventColumnKeys).optional().catch(undefined),
	dir: z.enum(['asc', 'desc']).optional().catch(undefined),
	page: z.int().min(1).optional().catch(undefined),
	signal: z
		.string()
		.refine((value) => parseSignalRange(value) !== undefined)
		.optional()
		.catch(undefined),
	c2c: z.boolean().optional().catch(undefined),
	sdp: z.enum(strikeDamagePotentialOptions).optional().catch(undefined),
	ellipse: z
		.union([z.literal(lightningReportErrorEllipseConfidences), z.literal('off')])
		.optional()
		.catch(undefined),
})
export type LightningReportSearch = z.infer<typeof LightningReportSearchSchema>

export const formatSignalRange = ({ min, max, inverted }: { min: number; max: number; inverted: boolean }) =>
	`${inverted ? '!' : ''}${min}..${max}`
